<template>
  <div>
    <add-payment-method-btn
      :customer-id="customerId"
      color="primary"
      rounded
      @added="push"
    />
    <payment-method-list
      :customer-id="customerId"
      class="q-mt-lg"
      ref="list"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PaymentMethod, List as ListElement } from '@/type';
import PaymentMethodList from './PaymentMethodList.vue';
import AddPaymentMethodBtn from './AddPaymentMethodBtn.vue';

export default defineComponent({
  components: { AddPaymentMethodBtn, PaymentMethodList },
  props: {
    customerId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    push(paymentMethod: PaymentMethod) {
      (this.$refs.list as ListElement).push(paymentMethod);
    },
  },
});
</script>
